var ad = require("@/components/adver/article_ad")
var HeadLogin = require("pc-login").loginBtnIndex
import NumberFix from "@/utils/number-text"
import LazyLoad from "@/components/lazyload"
// 设置Jquery依赖，解决delivery.js报错和评论组件报错问题
window.$ = window.Jquery = require('jquery')
window._ = require('underscore')
import Vue from "vue";
import RightSideBar from './vuecomps/rightSideBar/Index.vue'
import ArticleLike from './vuecomps/articleLike.vue' // 文末点赞
import { bindAriaEvent } from "./utils/bindAria.js"
import AllSeeList from './vuecomps/allSeeList.vue'
import  {jsonp} from './request/jsonp'
import MeComment from './vuecomps/comment/MeComment.vue'
import articleSGrade from '@/components/articleSGrade'
import { renderMiddleInsertVideo, renderRightBtns } from '@/pages/article_main/js/handleDom'
import Report from '@/components/report'
import { renderSpecialBenefits, renderHeadVideo } from '@/pages/article_main/js/handleDom'

export default function (opts) {
    opts.sGrade = articleSGrade(opts) ? articleSGrade(opts) : opts.sGrade
    window.pcArticleInfo = opts
    renderHeadVideo(opts) // 渲染头插视频
    renderMiddleInsertVideo() // 渲染中插视频
    renderSpecialBenefits(opts) // 权益逻辑处理
    //登录条
    new HeadLogin({
        el: '#head-login',
        mark: 'article',
        type: 'other',
    })
    var LazyLoadIns = new LazyLoad();
    // 右侧 文章等级为A、S-
    if (document.querySelector('#right-side-bar') && opts.sGrade < 2) {
        new Vue({
            el: '#right-side-bar',
            components: {
                RightSideBar,
            },
        })
    }
    init(opts)
    // 正文插入功能卡&推荐卡
    const mpPluginList = document.querySelectorAll('#mp-editor mp-plugin')
    if (mpPluginList?.length) {
        import(
            /* webpackChunkName: "article-insert" */ './vuecomps/article-insert/index.js'
        )
            .then((res) => {
                res?.renderArticleInsert()
            })
            .catch((err) => {
                console.log(err, '功能卡失败')
            })
    }
    //前端请求阅读数
    const articleId = window?.pcArticleInfo?.news_id
    jsonp(`//v2.sohu.com/public-api/articles/${articleId}/pv`).then((data) => {
        if (data) {
            const pvDom = document.querySelector("[data-role='pv']")
            if (pvDom) pvDom.innerHTML = new NumberFix(data).format()
        }
    })

    // 渲染评论
    if (!document.querySelector('#meComment')) return
    new Vue({
        el: '#meComment',
        components: {
            MeComment,
        },
    })
    if (!document.querySelector('#commentList')) return
    import(
        /* webpackChunkName: "article_comment_list" */ './vuecomps/comment/CommentList.vue'
    )
        .then((res) => {
            if (res && res.default) {
                const comp = res.default
                new Vue({
                    el: '#commentList',
                    components: {
                        CommentList: comp,
                    },
                })
            }
        })
        .catch((e) => {
            console.log('渲染失败，评论', e)
        })
    jumpToComment()
    // 展开更多功能
    const showMoreDom = document.querySelector('#showMore')
    if (showMoreDom) {
        showMoreDom.addEventListener('click', function (e) {
            e?.preventDefault()
            const hideEl = document.querySelector('.hidden-content')
            if (hideEl) hideEl?.classList?.remove('control-hide')
            const lookallBox = document.querySelector('.lookall-box')
            lookallBox?.classList?.add('control-hide')
            window?.sohuSpm?.sendAction({
                acode: 8434,
            })
        })
    }
    // 文末点赞
    if (document.querySelector('#article-like')) {
        new Vue({
            el: '#article-like',
            components: {
                articleLike: ArticleLike,
            },
        })
    }
}


function init(opts) {
    // 右侧悬浮按钮
    renderRightBtns()

    // 推荐阅读-商讯文章页
    if(document.querySelector('#groomRead') && opts.sGrade < 2) {
        import(/* webpackChunkName: "article_recommend" */'./vuecomps/groomRead.vue')
        .then((res)=>{
            const comp = res.default
            new Vue({
                el: "#groomRead",
                components: {
                    GroomRead: comp
                }
            })
        }).catch((e)=>{
            console.log('渲染失败，推荐阅读',e)
        })
    }

    ad.init({
        news_id: opts.news_id,
        media_id: opts.media_id,
        channel_id: opts.channel_id,
        categoryId: opts.categoryId,
        subid: opts.media_id,
        isBaidu: opts.isBaiDuAd,
        showAd: opts.sGrade == 0,
    })
    if(document.getElementById('articleAllsee') && opts.sGrade < 2 ) {
        new Vue({
            el: "#articleAllsee",
            components: {
                allSeeList: AllSeeList
            },
        })
    }

    const pcArticleInfo = window?.pcArticleInfo
    var isPort = pcArticleInfo?.originalStatus == 2 && pcArticleInfo?.originalId && pcArticleInfo?.originalId != 'null';
    if (isPort) {
        import(/* webpackChunkName: "article_transfer" */'./vuecomps/articleReprint.vue')
        .then((res)=>{
            if(res && res.default) {
                const comp = res.default
                new Vue({
                    el: "#articleTransfer",
                    components: {
                        transfer: comp
                    },
                })
            }
        })
    }

    // 处理无障碍，关怀版点击绑定
    bindAriaEvent()
    // 旧上报体系
    Report(opts)
}

// 评论跳转(js控制，css不准)
const jumpToComment = ()=>{
    // url携带#comment_area跳转
    if(window.location.hash == '#comment_area') {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; // 禁止自动恢复滚动位置
        }
        setTimeout(()=>{
            window.scrollTo(0, document.getElementById("meComment")?.offsetTop);
        },1500)
    }
}
